import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, interval, switchMap, takeWhile } from 'rxjs';
import { BusArtCallcenter } from '../models/BusArtCallcenter';
import {environment} from "../../../environments/environment";

@Injectable({providedIn: 'root'})

export class BuscadorArticuloService
{
  private hostPeticion : string = environment.articulosWSBase;
  constructor(private http: HttpClient){}

  //*recupera e inserta una nueva peticion en la tabla de
  //*bus_art_callcenter
  public getIdConsultaArticulo(token:string,usuario:string): Promise<number>
  {
    let url = this.hostPeticion + "/BusquedaCallcenter/getNuevoId";

    const httpOptions =
    {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
      .set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,'"'+usuario+'"',httpOptions)
      .subscribe
      ({
        next(res)
        {
          resolve(res);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        },
      })
    });
  }
  public getArticuloPorId(token:string,id:number):Promise<BusArtCallcenter>
  {
    let url = this.hostPeticion + "/BusquedaCallcenter/getArtById";

    const httpOptions =
    {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
      .set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,id,httpOptions)
      .subscribe
      ({
        next(res)
        {
          resolve(res);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        },
      })
    });
  }
  //*Abre el buscador de articulos al que luego, haremos un observable para
  //*detectar si sigue abierto
  public monitorBuscadorArt(idBusqueda:number, marca:string,modelo:string,empresa:number,ano?:string|number): Observable<boolean>
  {
    let url = environment.buscadorArticulo;
    url += "ralarsa/include/buscador_paso_a_paso_new.php?ie&e="+empresa+"&marca=" + marca.trim() + "&modelo=" + modelo.trim() + "&ano=" + ano;
    url+="&callcenter="+idBusqueda;

    const windowFeatures = "width=1000,height=1000";
    return new Observable<boolean>((observer) =>
    {
      const newWindow = window.open(url, "_blank", windowFeatures);
      const checkInterval = setInterval(() =>
      {
        if (newWindow!.closed)
        {
          clearInterval(checkInterval);
          observer.next(true); // Emitimos un valor para indicar que la ventana se cerró
          observer.complete(); // Completamos el observable
        }
        else{}
      }, 100); // Intervalo de verificación en milisegundos

      // En caso de que el observable se desuscriba, limpiamos el intervalo
      return () =>
      {
        clearInterval(checkInterval);
      };
    });
  }
  public monitorBuscadorArtTuVoz(token:string,idBusqueda:number, marca:string,modelo:string,empresa:number,ano?:string|number): Observable<boolean>
  {
    //let resLogin = this.loginAutoRalarsa().subscribe();
    let url = environment.buscadorArticulo;
    url += "ralarsa/include/buscador_paso_a_paso_new.php?ie&e="+empresa+"&marca=" + marca.trim() + "&modelo=" + modelo.trim() + "&ano=" + ano;
    url+="&callcenter="+idBusqueda+"&token="+token;

    const windowFeatures = "width=1000,height=1000";
    return new Observable<boolean>((observer) =>
    {
      // Abrimos la nueva ventana
      const newWindow = window.open(url, "_blank", windowFeatures);
      // Verificamos periódicamente si la ventana se ha cerrado
      const checkInterval = setInterval(() =>
      {
        if (newWindow!.closed)
        {
          clearInterval(checkInterval);
          observer.next(true); // Emitimos un valor para indicar que la ventana se cerró
          observer.complete(); // Completamos el observable
        }
        else{}
      }, 100); // Intervalo de verificación en milisegundos

      // En caso de que el observable se desuscriba, limpiamos el intervalo
      return () =>
      {
        clearInterval(checkInterval);
      };
    });
  }
}

